import React from 'react';

export const ArrowDown = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='10'
            height='10'
            viewBox='0 0 10 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M5.00004 0.757359L5.00003 9.24264M5.00003 9.24264L9.24268 5M5.00003 9.24264L0.757394 5'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default ArrowDown;
